import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/*
Copyright (c) 2018-2019 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY


import * as React from 'react';
export default function FlagAT(props) {
  return React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAVUExURe0xQ/E4SvU/UP39/fn5+fT09PHx8YdbDj0AAAEgSURBVDjLzVRBbsJADLR/sM4Lun0BUvyASDF3DglnLuH/T6g93gTRoqgHoJ11Zmc9I24Dfe7jg94QkM4hNaarecWNz41CtYo0XwRJR2qp0hWSffwiUIKLcHESUF7cFJEPc/gp2Bd4M0GTkzOtouRBOLbpbeD753f7Vej3cXhCYOx70370cWiqHLdVD2RmowXUTyhVtQ06kCkiesu19wgeyPYx0DFhE8iRDOUYaLbJfDUfpyAHGHaETjQnfL+qVcyxOtFm3Hkbtl8AlkeBa2BZzuf4XPhAte0FgeX6CNhmYAcX+h/tRnVR2ChyJ1nkmutC8MOrkar4B1hP96x2e4+Zs84FvZbctXZ7Z6PHBfVm9Lq1vbUb/q2r2IB/tpv/qt1fpYTGyqRr6dUAAAAASUVORK5CYII=",
    alt: "AT"
  }, props));
}